/* import __COLOCATED_TEMPLATE__ from './select-all-checkbox-manager-market.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
/**
@param {Array} [options] - An array of options. Each option should have an `checked` attribute for initializing and managing selection state. An `isDisabled` attribute will be respected when selecting all, if present.
@param {Action} [onChange] - Optional - An action that triggers when the selections change. `onChange` will always be passed the full list of currently selected options, as well as a change type.
                             The change type will be one of `ALL`, `NONE`, or `SINGLE`. When the change type is `SINGLE`, the changed option will be provided as the 3rd argument.
@param {Boolean} [enableSelectAll=false] - Optional - Whether to show the select all option.
@param {Boolean} [enableIndeterminateState=false] - Optional - Whether to show an indeterminate select all checkbox state.
@param {String} [selectAllLabel] - Select all label. MUST be provided if enableSelectAll is true.
*/

import { set, computed, action } from '@ember/object';
import { equal, filterBy } from '@ember/object/computed';
import Component from '@ember/component';
const CHECKBOX_STATE = {
  UNCHECKED: 'false',
  CHECKED: 'true',
  INDETERMINATE: 'indeterminate'
};
export const CHECKBOX_MANAGER_CHANGE_TYPES = {
  ALL: 'ALL',
  NONE: 'NONE',
  SINGLE: 'SINGLE'
};
let SelectAllCheckboxManager = (_dec = computed('options', 'useMarketListEvents'), _dec2 = computed('isSelectedAll', 'isSelectedNone'), _dec3 = filterBy('options', 'checked'), _dec4 = equal('selectedOptions.length', 0), _dec5 = computed('selectedOptions.[]', 'options.[]', 'isSelectedNone'), _class = class SelectAllCheckboxManager extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "selectedOptions", _descriptor, this);
    _initializerDefineProperty(this, "isSelectedNone", _descriptor2, this);
  }
  init(...args) {
    super.init(args);
    this.set('useMarketListEvents', this.enableSelectAll && this.enableIndeterminateState);
    // if true, we listen for change events from the market-list.
    // if false, we listen for change events from each market-row.
    //
    // we should probably always use the market-list events, but this
    // component is in transition and not all consumers yet work with the new
    // branch. from what i've seen it's mostly due to their tests having
    // more specific exptations about DOM properties than they should, but
    // otherwise work ok.
  }
  get startingValue() {
    return this.options.filter(o => o.checked).map(o => o.value).join(',');
  }
  get selectAllCheckedState() {
    if (!this.isSelectedAll && !this.isSelectedNone) {
      return CHECKBOX_STATE.INDETERMINATE;
    } else if (this.isSelectedAll) {
      return CHECKBOX_STATE.CHECKED;
    } else {
      return CHECKBOX_STATE.UNCHECKED;
    }
  }
  get isSelectedAll() {
    return !this.isSelectedNone && this.selectedOptions.length === this.options.length;
  }
  selectAllDidChange(checked) {
    if (this.useMarketListEvents) {
      return;
    }
    this.options.rejectBy('disabled').forEach(option => {
      set(option, 'checked', checked);
    });
    this.onChange?.(this.selectedOptions, checked ? CHECKBOX_MANAGER_CHANGE_TYPES.ALL : CHECKBOX_MANAGER_CHANGE_TYPES.NONE);
  }
  optionDidChange(option, checked) {
    if (this.useMarketListEvents) {
      return;
    }
    set(option, 'checked', checked);
    this.onChange?.(this.selectedOptions, CHECKBOX_MANAGER_CHANGE_TYPES.SINGLE, option);
  }
  onMarketListSelectionsDidChange(event) {
    if (!this.useMarketListEvents) {
      return;
    }

    // some consumers rely on this component manipulating the "checked"
    // property of these objects; until they listen for events, we have to keep
    // that for backward compatibility:
    let option;
    if (event.detail.newDeselectionValue) {
      option = this.options.find(o => o.value === event.detail.newDeselectionValue);
      set(option, 'checked', false);
    }
    if (event.detail.newSelectionValue) {
      option = this.options.find(o => o.value === event.detail.newSelectionValue);
      set(option, 'checked', true);
    }
    if (event.detail.newSelectionValue === undefined) {
      this.options.forEach(o => set(o, 'checked', true));
    }
    if (event.detail.newDeselectionValue === undefined) {
      this.options.forEach(o => set(o, 'checked', false));
    }

    // i see no clearer indication on this event that it came from a
    // "select all" interaction
    // https://github.com/squareup/market/issues/7795
    /* eslint-disable prettier/prettier */
    const changeType = event.detail.newSelectionValue === undefined ? CHECKBOX_MANAGER_CHANGE_TYPES.ALL : event.detail.newDeselectionValue === undefined ? CHECKBOX_MANAGER_CHANGE_TYPES.NONE : CHECKBOX_MANAGER_CHANGE_TYPES.SINGLE;
    /* eslint-enable */

    // we notify our consumer, which is the preferred way:
    this.onChange?.(this.options.filter(o => o.checked), changeType, option);
  }
}, _applyDecoratedDescriptor(_class.prototype, "startingValue", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "startingValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectAllCheckedState", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "selectAllCheckedState"), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, "selectedOptions", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isSelectedNone", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isSelectedAll", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "isSelectedAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectAllDidChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectAllDidChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "optionDidChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "optionDidChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onMarketListSelectionsDidChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onMarketListSelectionsDidChange"), _class.prototype), _class);
export { SelectAllCheckboxManager as default };